import * as React from "react";
import { AnimatePresence } from "motion/react";
import { useSelector, useDispatch } from "@grandvisionhq/state";
import { ShippingObjectTypes } from "../../../../state.js";
import { updateShippingDetails } from "../../../StepShipping/actions.js";
import { HighlightedForm } from "../../../components/StepShipping/components/HighlightedForm.js";
import { getCompany, getCompanyFormData } from "../../../StepShipping/selectors.js";
import { useIsFormSlotAvailable } from "../../../../slots/forms/slots/forms/form-context.js";
import { CheckoutForm } from "../../../../components/Forms/components/Forms/CheckoutForm.js";
import { FormFieldsWithCart } from "../../../../components/FormFieldsWithCart/components/FormFieldsWithCart/FormFieldsWithCart.js";
const CompanyFormContainer = () => {
  const isCompanyFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Company);
  const companyDetails = useSelector(getCompany);
  const dispatch = useDispatch();
  const companyFormInitialData = useSelector(getCompanyFormData);
  const handleChange = React.useCallback(
    (formData) => {
      dispatch(updateShippingDetails({ form: formData }));
    },
    [dispatch]
  );
  if (!isCompanyFormAvailable) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(AnimatePresence, null, Boolean(companyDetails) && /* @__PURE__ */ React.createElement(HighlightedForm, { key: "company-highlight", className: "checkout-step__highlight" }, /* @__PURE__ */ React.createElement(
    CheckoutForm,
    {
      formName: "company",
      "data-t": "company",
      initialFormState: companyFormInitialData,
      onChange: handleChange
    },
    /* @__PURE__ */ React.createElement(FormFieldsWithCart, { formName: ShippingObjectTypes.Company })
  )));
};
export {
  CompanyFormContainer
};
//# sourceMappingURL=CompanyFormContainer.js.map
